import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import Groups from './Groups';
import SubscriptionsTable from './SubscriptionsTable';

import './SubscriptionsWithGroups.css';

@inject('filterStore', 'translationsStore', 'commonStore', 'subscriptionsStore')
@observer
export default class SubscriptionsWithGroups extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedRows: [],
      selectedGroup: 'allgroups'
    };
  }

  componentDidMount = () => {
  };

  componentWillUnmount() {
    this.props.filterStore.reset();
  }

  onGroupChange = () => {
    this.resetTableView();
  };

  onSelectedRowsChange = selectedRows => {
    this.setState({ selectedRows });
  };

  resetTableView = () => {
    this.setState({ selectedRows: [] });
  };

  apply = () => {
    this.props.filterStore.apply();
  };

  render() {
    const { subscriptions, subscriptionsFiltered, filterStore } = this.props;
    const { selectedRows, selectedGroup } = this.state;

    return (
      <div className="SubscriptionsWithGroups">
        <React.Fragment>
          <Groups
            subscriptions={subscriptions}
            onSelect={({ selected, group }) => {
              this.setState({ selectedGroup: selected, groupData: null });
              filterStore.remove('groupFilter');
              if (selected === 'combined') {
                filterStore.add('groupFilter.group_combined', subscription => !subscription.available);
              }
              if (selected === 'free') {
                filterStore.add('groupFilter.group_free', subscription => subscription.available && new Date(subscription.end_date) >= new Date());
              }
              filterStore.apply();
            }}
            selected={selectedGroup}
            onGroupChange={this.onGroupChange}
          />
          <div style={{ display: 'flex', flexDirection: 'column' }} className="content">
            <SubscriptionsTable
              subscriptions={subscriptionsFiltered}
              selectedRows={selectedRows}
              onSelectedRowsChange={this.onSelectedRowsChange}
            />
          </div>
        </React.Fragment>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/SubscriptionManagerDashboard/SubscriptionsWithGroups/SubscriptionsWithGroups.js